export const ornekVideolarData = {
  title: "Yaşasın Hamileyim",
  sections: [
    {
      id: 1,
      title: "Merhaba",
      lessons: [
        {
          id: 1,
          title: "Başlıyoruz",
          duration: "2:19",
          videoUrl: "https://player.vimeo.com/external/1137642078.m3u8?s=e0396131578c345eee911932b636ebd8e899a9ca&logging=false",
          url2160p: "https://player.vimeo.com/progressive_redirect/playback/1137642078/rendition/2160p/file.mp4?loc=external&signature=12d267438b640d408b9db8dd83d11e565675c524683fba19f128a88e9d917d20",
          url1440p: "https://player.vimeo.com/progressive_redirect/playback/1137642078/rendition/1440p/file.mp4?loc=external&signature=b52c416d92a8e888b474cb84def38a25fb7439a8a45a291a44824a08f29ce970",
          url1080p: "https://player.vimeo.com/progressive_redirect/playback/1137642078/rendition/1080p/file.mp4?loc=external&signature=5017dc920eb0ace5122212e8af7e4efc856e140c1214ace7c77924e210b915dd",
          url720p: "https://player.vimeo.com/progressive_redirect/playback/1137642078/rendition/720p/file.mp4?loc=external&signature=915802cded61e68c48ea00d8f19d4a713cfe3de6f21ec2f30db1c7158ad69a68",
          url360p: "https://player.vimeo.com/progressive_redirect/playback/1137642078/rendition/360p/file.mp4?loc=external&signature=08a13a933577dfa5b1ccb7bdeb65c3ee74984583712d6105214324214d50758f"
        },
        {
          id: 2,
          title: "Yolculuğun İlk Adımı",
          duration: "0:52"
        },
        {
          id: 3,
          title: "Yumurta ve Spermin Aşkı",
          duration: "1:14"
        },
        {
          id: 4,
          title: "Dış Gebelik ve Boş Gebelik",
          duration: "3:18"
        },
        {
          id: 5,
          title: "Başrol Oyuncusuna Tavsiyeler",
          duration: "3:09"
        }
      ]
    },
    {
      id: 2,
      title: "1. Trimester",
      lessons: [
        {
          id: 6,
          title: "Doktora Ne Zaman Gidelim?",
          duration: "2:12"
        },
        {
          id: 7,
          title: "Doktor Seçimi",
          duration: "4:13"
        },
        {
          id: 8,
          title: "Kanamalar ve Düşük Riski",
          duration: "1:44"
        },
        {
          id: 9,
          title: "1. Trimester(İlk 3 Ay)",
          duration: "5:49"
        },
        {
          id: 10,
          title: "Hormonlar Dorukta",
          duration: "6:36"
        },
        {
          id: 11,
          title: "Tarama Testleri",
          duration: "3:13"
        },
        {
          id: 12,
          title: "Tarama Testlerini Yaptırmak Zorunda Mıyım?",
          duration: "1:11"
        },
        {
          id: 13,
          title: "Bebeğimin Cinsiyeti",
          duration: "4:18"
        },
        {
          id: 14,
          title: "Ne Yiyelim, Ne İçelim?",
          duration: "6:22"
        },
        {
          id: 15,
          title: "Beslenme ve Hormonlar",
          duration: "2:34"
        },
        {
          id: 16,
          title: "Gebelikte Fizyolojik Değişiklikler",
          duration: "0:58"
        },
        {
          id: 17,
          title: "Gebelik ve Beyin",
          duration: "6:06"
        },
        {
          id: 18,
          title: "Gebelik ve Kalp",
          duration: "2:43"
        },
        {
          id: 19,
          title: "Gebelik ve Akciğer",
          duration: "2:22"
        },
        {
          id: 20,
          title: "Gebelik ve Sindirim Sistemi",
          duration: "1:51"
        },
        {
          id: 21,
          title: "Gebelik ve Üriner Sistem",
          duration: "2:47"
        }
      ]
    },
    {
      id: 3,
      title: "Kısa Sorulara Cevaplar (1.Trimester)",
      lessons: [
        {
          id: 22,
          title: "Doğum Zamanı Nasıl Hesaplanır?",
          duration: "2:34"
        },
        {
          id: 23,
          title: "Kanamadan Korkmalı Mıyım?",
          duration: "1:50"
        },
        {
          id: 24,
          title: "Karnımı Sarsan Durumlar Düşüğe Sebep Olur Mu?",
          duration: "0:58"
        },
        {
          id: 25,
          title: "Acaba İkizlerimiz Mi Olacak?",
          duration: "1:33"
        },
        {
          id: 26,
          title: "Sigara",
          duration: "1:58"
        },
        {
          id: 27,
          title: "Can Dostum Evden Uzaklaşmalı Mı?",
          duration: "1:46"
        },
        {
          id: 28,
          title: "Gebelikte Cinsel İlişki Zararlı Mı?",
          duration: "1:37"
        },
        {
          id: 29,
          title: "Kan Uyuşmazlığı",
          duration: "2:23"
        },
        {
          id: 30,
          title: "Deniz - Havuza Girebilir Miyim?",
          duration: "1:17"
        },
        {
          id: 31,
          title: "Hamilelikte Vajinal Akıntılardan Korkmalı Mıyım?",
          duration: "1:09"
        }
      ]
    },
    {
      id: 4,
      title: "2. Trimester",
      lessons: [
        {
          id: 32,
          title: "16. Hafta",
          duration: "2:54"
        },
        {
          id: 33,
          title: "20. Hafta",
          duration: "2:11"
        },
        {
          id: 34,
          title: "24. Hafta",
          duration: "4:24"
        },
        {
          id: 35,
          title: "Şeker Yükleme Testi",
          duration: "3:56"
        },
        {
          id: 36,
          title: "26-27. Haftalar",
          duration: "2:07"
        }
      ]
    },
    {
      id: 5,
      title: "Kısa Sorulara Cevaplar (2.Trimester)",
      lessons: [
        {
          id: 37,
          title: "Gebelikte Görüntüleme Yöntemleri",
          duration: "4:15"
        },
        {
          id: 38,
          title: "Gebelikte Yolculuk Yapabilir Miyim?",
          duration: "1:12"
        },
        {
          id: 39,
          title: "Hamilelikte Saç Boyanır Mı - Kesilir Mi?",
          duration: "1:13"
        },
        {
          id: 40,
          title: "Gebelikte Saç Problemleri",
          duration: "1:30"
        },
        {
          id: 41,
          title: "Hamilelikte Cilt Problemleri ve Cilt Sağlığı",
          duration: "3:59"
        },
        {
          id: 42,
          title: "Gebelikte Yatış Pozisyonu Nasıl Olmalı?",
          duration: "1:32"
        },
        {
          id: 43,
          title: "Gebelikte Diş ve Diş Eti Problemleri",
          duration: "3:18"
        },
        {
          id: 44,
          title: "Mememden Süt Geliyor, Korkmalı Mıyım?",
          duration: "1:09"
        },
        {
          id: 45,
          title: "Gebelik ve Oruç",
          duration: "2:35"
        },
        {
          id: 46,
          title: "Gribal Enfeksiyona Yakalanırsam Ne Yapmalıyım?",
          duration: "1:46"
        }
      ]
    },
    {
      id: 6,
      title: "3. Trimester",
      lessons: [
        {
          id: 47,
          title: "3. Trimester",
          duration: "1:36"
        },
        {
          id: 48,
          title: "31-34. Haftalar",
          duration: "2:03"
        },
        {
          id: 49,
          title: "Gebelikte Özlük Hakları",
          duration: "4:46"
        },
        {
          id: 50,
          title: "35-38. Haftalar",
          duration: "1:39"
        },
        {
          id: 51,
          title: "Fetal İyilik Halinin Takibi",
          duration: "4:24"
        },
        {
          id: 52,
          title: "Baba Adaylarına Öneriler",
          duration: "4:47"
        },
        {
          id: 53,
          title: "Hiç(Her Şeye Burnunu Sokan İnsan Çeşidi)",
          duration: "2:36"
        }
      ]
    },
    {
      id: 7,
      title: "Kısa Sorulara Cevaplar (3. Trimester)",
      lessons: [
        {
          id: 54,
          title: "Gebelikte Bel-Kasık Ağrıları",
          duration: "4:37"
        },
        {
          id: 55,
          title: "Gebelikte Ödem ve Alınacak Önlemler",
          duration: "2:55"
        },
        {
          id: 56,
          title: "El Uyuşmazlığı ve El Bileği Ağrısı",
          duration: "2:23"
        },
        {
          id: 57,
          title: "Gebelikte Kramp-Spazm Normal mi?",
          duration: "1:42"
        },
        {
          id: 58,
          title: "Hamilelikte Burun ve Diş Eti Kanaması Olabilir Mi?",
          duration: "1:57"
        },
        {
          id: 59,
          title: "Bebek Hareketlerini Takip Etmeli Miyim?",
          duration: "1:32"
        },
        {
          id: 60,
          title: "Plasenta",
          duration: "2:15"
        },
        {
          id: 61,
          title: "Plasenta Yerleşim Anomalileri",
          duration: "2:08"
        },
        {
          id: 62,
          title: "Kordon Dolanması",
          duration: "1:58"
        },
        {
          id: 63,
          title: "Kordon Kanı ve Kordon Bağı",
          duration: "2:49"
        }
      ]
    },
    {
      id: 8,
      title: "Gebelik Komplikasyonları",
      lessons: [
        {
          id: 64,
          title: "Preeklampsi",
          duration: "4:49"
        },
        {
          id: 65,
          title: "Erken Doğum",
          duration: "06:40"
        },
        {
          id: 66,
          title: "Kanamalar",
          duration: "4:23"
        },
        {
          id: 67,
          title: "Bulantı ve Kusmalar",
          duration: "5:10"
        },
        {
          id: 68,
          title: "Gebelikte Tiroit Bozuklukları",
          duration: "6:52"
        },
        {
          id: 69,
          title: "Gebelikte Kan Değerleri",
          duration: "3:31"
        }
      ]
    },
    {
      id: 9,
      title: "Doğum",
      lessons: [
        {
          id: 70,
          title: "Mucize Doğuyor",
          duration: "1:06"
        },
        {
          id: 71,
          title: "Doğuma Hazırlık",
          duration: "5:39"
        },
        {
          id: 72,
          title: "Anne ve Bebek Çantası Hazırlığı",
          duration: "12:14"
        },
        {
          id: 73,
          title: "Ne Zaman Hastaneye Geçelim?",
          duration: "6:28"
        },
        {
          id: 74,
          title: "Hastaneye Yatış",
          duration: "5:16"
        },
        {
          id: 75,
          title: "Doğum Şekilleri",
          duration: "3:15"
        },
        {
          id: 76,
          title: "Suya Doğum",
          duration: "6:57"
        },
        {
          id: 77,
          title: "Vajinal Doğum İçin Gerekli Koşullar",
          duration: "6:43"
        },
        {
          id: 78,
          title: "Vajinal Doğum - Sezeryan Doğum",
          duration: "4:16"
        },
        {
          id: 79,
          title: "Doğum Odası",
          duration: "3:19"
        },
        {
          id: 80,
          title: "Doğumun Evreleri",
          duration: "15:57"
        },
        {
          id: 81,
          title: "Doğumhaneye Geçiş",
          duration: "8:23"
        },
        {
          id: 82,
          title: "Doğum İçin Tüyolar",
          duration: "3:10"
        },
        {
          id: 83,
          title: "Minik Mucize Doğdu",
          duration: "2:04"
        },
        {
          id: 84,
          title: "Doğumun 3. Evresi",
          duration: "2:59"
        },
        {
          id: 85,
          title: "Doğumda Farklı Senaryolar",
          duration: "5:34"
        },
        {
          id: 86,
          title: "Sezaryen Doğum",
          duration: "6:15"
        },
        {
          id: 87,
          title: "Doğumun 4. Evrsei (Lohusa Dönemi)",
          duration: "3:38"
        },
        {
          id: 88,
          title: "Doğum Sonrası Odaya Geçiş",
          duration: "7:52"
        }
      ]
    },
    {
      id: 10,
      title: "Yeni Doğan Bakımı",
      lessons: [
        {
          id: 89,
          title: "Doğam Odasında İlk Bakım",
          duration: "4:04"
        },
        {
          id: 90,
          title: "Merak Edilen Sorulara Cevaplar",
          duration: "5:42"
        },
        {
          id: 91,
          title: "Hastane Odasında Bakım",
          duration: "4:09"
        },
        {
          id: 92,
          title: "Merak Edilen Sorulara Cevaplar-2",
          duration: "4:02"
        },
        {
          id: 93,
          title: "Evde Bebek Bakımı",
          duration: "12:28"
        },
        {
          id: 94,
          title: "Yeni Doğan Sarılığı",
          duration: "2:18"
        },
        {
          id: 95,
          title: "Merak Edilen Sorulara Cevaplar-3",
          duration: "4:11"
        },
        {
          id: 96,
          title: "İlk Kontrol",
          duration: "4:25"
        },
        {
          id: 97,
          title: "İlk Ayda Karşılaşabileceğimiz Bazı Durumlar",
          duration: "5:15"
        },
        {
          id: 98,
          title: "Ne Alalım, Ne Almayalım?",
          duration: "9:28"
        },
        {
          id: 99,
          title: "Bebek Odası Nasıl Olmalı?",
          duration: "5:13"
        },
        {
          id: 100,
          title: "Merak Edilen Sorulara Cevaplar-4",
          duration: "4:31"
        }
      ]
    },
    {
      id: 11,
      title: "Emzirme ve Bebek Bakımı",
      lessons: [
        {
          id: 101,
          title: "Emzirme Eğitimi",
          duration: "4:07",
          videoUrl: "https://player.vimeo.com/external/1139328023.m3u8?s=477829dba699569e9b706b8d55900e76cd0c558f&logging=false",
          url2160p: "https://player.vimeo.com/progressive_redirect/playback/1139328023/rendition/2160p/file.mp4?loc=external&signature=c9e81b3426920d75c23111b74a7a790fcb61ee62dc296453f5aadf3fb8ed112d",
          url1440p: "https://player.vimeo.com/progressive_redirect/playback/1139328023/rendition/1440p/file.mp4?loc=external&signature=3e7358fc9357f4fd4e5a9dc74959951e4d16b78bc86620324a7a50db397ce07b",
          url1080p: "https://player.vimeo.com/progressive_redirect/playback/1139328023/rendition/1080p/file.mp4?loc=external&signature=1920827a9fea5367182422d0569626dfc4f313e825237f7ec6d9472f9974e452",
          url720p: "https://player.vimeo.com/progressive_redirect/playback/1139328023/rendition/720p/file.mp4?loc=external&signature=97b8c1dcdb1e8cdfa53a789b6ad26340e88221a7ce7ee67fd00cd1c78b8a37c1",
          url360p: "https://player.vimeo.com/progressive_redirect/playback/1139328023/rendition/360p/file.mp4?loc=external&signature=5e286038b92fe6da915f502f80a79d8f15ae5803c707e4ce57b60f846b38bd22"
        },
        {
          id: 102,
          title: "İlk Emzirme",
          duration: "6:29"
        },
        {
          id: 103,
          title: "Emzirme Pozisyonları",
          duration: "7:30"
        },
        {
          id: 104,
          title: "Emzirme Döneminde Yaşanabilecek Sorunlar",
          duration: "5:55"
        },
        {
          id: 105,
          title: "Sütüm Yeterince Geliyor Mu? Süt Arttırıcı Yöntemler",
          duration: "4:02"
        },
        {
          id: 106,
          title: "Doğumda Ebenin Rolü",
          duration: "5:27"
        },
        {
          id: 107,
          title: "Evde Bebek Bakımı",
          duration: "19:58"
        }
      ]
    },
    {
      id: 12,
      title: "Hamilelik ve Lohusa Dönemine Psikolojik Bakış",
      lessons: [
        {
          id: 108,
          title: "Minik Mucizeye Psikolojik Hazırlık",
          duration: "4:44"
        },
        {
          id: 109,
          title: "Kaygıda Geçmişin Rolü",
          duration: "2:45"
        },
        {
          id: 110,
          title: "Baba Adayının Rolü",
          duration: "2:05"
        },
        {
          id: 111,
          title: "Beden Algısı",
          duration: "1:24"
        },
        {
          id: 112,
          title: "Doğum Üzerine",
          duration: "2:29"
        },
        {
          id: 113,
          title: "İlk Temas",
          duration: "1:14"
        },
        {
          id: 114,
          title: "Emzirme Üzerine",
          duration: "5:06"
        },
        {
          id: 115,
          title: "Meme Reddi",
          duration: "1:35"
        },
        {
          id: 116,
          title: "Postpartum Depresyon",
          duration: "4:19"
        },
        {
          id: 117,
          title: "Lohusaya Destek",
          duration: "3:02"
        },
        {
          id: 118,
          title: "Süreç Üzerine Soru-Cevap",
          duration: "10:15"
        }
      ]
    },
    {
      id: 13,
      title: "Hamilelikte Beslenme",
      lessons: [
        {
          id: 119,
          title: "Gebelik ve Beslenme",
          duration: "0:33"
        },
        {
          id: 120,
          title: "1.Trimesterde Beslenme",
          duration: "13:54"
        },
        {
          id: 121,
          title: "Ara Öğünler",
          duration: "9:10"
        },
        {
          id: 122,
          title: "2.Trimesterde Beslenme",
          duration: "4:06"
        },
        {
          id: 123,
          title: "3.Trimesterde Beslenme",
          duration: "9:18"
        },
        {
          id: 124,
          title: "Gebelikte Dikkat Edilmesi Gereken Besinler",
          duration: "5:53"
        },
        {
          id: 125,
          title: "Vegan-Vejeteryan Anne Beslenmesi",
          duration: "3:07"
        },
        {
          id: 126,
          title: "Emzirme Döneminde Beslenme",
          duration: "4:07"
        }
      ]
    },
    {
      id: 14,
      title: "Gebelikte Pilates",
      lessons: [
        {
          id: 127,
          title: "Gebelikte Pilates",
          duration: "6:49"
        }
      ]
    },
    {
      id: 15,
      title: "Doğumda Anestezi",
      lessons: [
        {
          id: 128,
          title: "Doğumda Anestezi",
          duration: "18:53"
        }
      ]
    },
    {
      id: 16,
      title: "Nefes",
      lessons: [
        {
          id: 129,
          title: "Nefes",
          duration: "8:05"
        },
        {
          id: 130,
          title: "Doğumda Nefes",
          duration: "2:23"
        },
        {
          id: 131,
          title: "Lohusa Döneminde Nefes",
          duration: "2:02"
        }
      ]
    },
    {
      id: 17,
      title: "Yurt Dışında Doğum",
      lessons: [
        {
          id: 132,
          title: "Amerika'da Doğum",
          duration: "18:15"
        },
        {
          id: 133,
          title: "İngiltere'de Doğum",
          duration: "14:14"
        }
      ]
    },
    {
      id: 18,
      title: "Doğum Fotoğrafçılığı ve Organizasyon",
      lessons: [
        {
          id: 134,
          title: "Doğum Fotoğrafçılığı",
          duration: "14:39"
        },
        {
          id: 135,
          title: "Oda Süsleme",
          duration: "3:57"
        }
      ]
    }
  ]
};
